(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Nonogram", [], factory);
	else if(typeof exports === 'object')
		exports["Nonogram"] = factory();
	else
		root["Nonogram"] = factory();
})(window, function() {
return 